import { useContext } from 'react';
import Login from './components/Auth/Login';
import UserContext from './context/userContext';
import Dashboard from './components/Dashboard/Dashboard';
import { Outlet, useLocation } from 'react-router';
import Nav from './components/Nav/Nav';
//import Footer from './components/Footer'

const Main = () => {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();
  const url = location.pathname;

  return (
    <div>
      {!user ? (
        <Login />
      ) : (
        <>
          <Nav
            rol={user.rol}
            moroso={user.moroso}
          />
          {user.moroso && (
            <div className="bg-danger d-flex justify-content-center text-white py-2">
              Usuario suspendido, cubrir adeudo, contacta a tu ejecutivo de
              postventa.
            </div>
          )}
          {url === '/' || url === '/resumen' ? (
            <Dashboard
              user={user}
              setUser={setUser}
            />
          ) : (
            <Outlet />
          )}
          {/* 	<Footer /> */}
        </>
      )}
    </div>
  );
};

export default Main;
